<div class="analysis-top-bar" [ngClass]="variant">
  <div class="bar-zone bar-start">
    <ng-content select="[barStart]"></ng-content>
  </div>
  <div class="bar-zone bar-center">
    <ng-content select="[barCenter]"></ng-content>
  </div>
  <div class="bar-zone bar-end">
    <ng-content select="[barEnd]"></ng-content>
  </div>
</div>
